import React from 'react';

const Header2 = () => {
  return (
     <div className="header-fix">
        <p className="alpha-text">Alpha version now released! Try our visual drag and drop builder now!</p>
     </div>
  )
}

export default Header2;
